const state = {
  pathTo: ''
}

const mutations = {
  show (state, path) {
    state.pathTo = path
  },
  close (state) {
    state.pathTo = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
